import { callbackify } from "util";
import Api from "@/services/api.js";
import Log from "@/services/log.js";
import ApiImportador from "@/services/importador.js";
import vSelect from "vue-select";
import vTributos from "@/components/v-tributos/v-tributos.vue";
import InputMensagemErro from "@/components/input-mensagem-erro.vue";
import ConfirmModal from "@/components/ConfirmModal/ConfirmModal.vue";
import CounterNcm from "@/modules/Pesquisa/components/Head/CounterNcm.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import stringFormatMixin from "@/mixins/stringFormatMixin";
import ModalProduto from "@/components/ModalProduto/ModalProduto.vue";
import ModalVigente from "@/components/ModalProduto/ModalVigente.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import ModalCompreende from "@/components/ModalCompreende/ModalCompreende.vue";
import ModalImportacao from "@/components/ModalImportacao/ModalImportacao.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";
import TabelaProdutos from "./TabelaProdutos.vue";
import CenarioInput from "@/components/CenarioInput/CenarioInput.vue";
import MensagemSemResultados from "@/components/MensagemSemResultados/MensagemSemResultados.vue";
import MensagemUpgrade from "@/components/MensagemUpgrade/MensagemUpgrade.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";
import ModalExcluirProduto from "@/components/ModalProduto/ModalExcluirProduto.vue";

import { mapGetters, mapActions } from "vuex";
import { isThisMinute } from "date-fns";
import { nextTick } from "process";

var $ = require("jquery");
var elemento = "";
export default {
  // props: ["empresa"],
  components: {
    vSelect,
    vTributos,
    InputMensagemErro,
    ConfirmModal,
    Paginacao,
    CounterNcm,
    ModalProduto,
    ModalVigente,
    BotaoPadrao,
    ModalCompreende,
    ModalImportacao,
    PaginaTitulo,
    TabelaProdutos,
    CenarioInput,
    MensagemSemResultados,
    MensagemUpgrade,
    BotaoPadrao,
    LoadingPadraoContainer,
    ModalExcluirProduto
  },
  inject: ["pushAlert"],
  mixins: [stringFormatMixin],
  data() {
    return {
      dadosProdutoDelete: {},
      loteLoading: false,
      reverse: false,
      tituloModalProduto: "adicionar",
      atualizaModal: false,
      editarProdutoData: null,
      conteudoModalVigente: null,
      produtosPaginados: null,
      produtosFiltrados: [],
      cestOptions: ["-"],
      cest: "-",
      exOptions: [],
      nav_termo: "",
      termo: "",
      ex: "",
      listaNcm: [],
      msg: "Olá Mundo!",
      active: false,
      produto: [],
      produtos: [],
      produtoDelete: -1,
      titleModal: "",
      blCheckAll: false,
      arProdutoExcluir: [],
      strPesquisa: "",
      strOrdem: "",
      file: "",
      arquivoValido: false,
      retornoArquivo: "",
      arNcmProdutos: [],
      qtdeSelecaoCenario: 0,
      qtdeNcmsBuscados: 0,
      selected_destinacao: [
        {
          value: "",
          label: "Selecione uma Destinacao"
        }
      ],
      options_destinacao: [],
      msgs: [],
      assinatura: [],
      showColunas: ["normal", "nao-vigente", "alterado", "incompleto"],
      blLoadingButton: false,
      paginate: ["produtos"],
      acesso_simulado: localStorage.getItem("token_simulacao") ? true : false,
      keyTributos: 0,
      prodSelecionado: null,
      arProdutoEditar: [],
      blChangeAll: false,
      alertas: [],
      assinatura_id: "",
      assinatura_qtde_produto: 10,
      assinatura_plano: "Premium 01",
      bypassNCM: false,
      qtde_produto_cenario: 10,
      keyNcm: 1,
      quantidadeGrid: 10,
      acceptSuggestion: false,
      dataProduct: {},
      titleSuggestion: "NCM correspondente",
      blLoadingImportar: false,
      blLoadingSalvar: false,
      blLoadingExcluir: false,
      blLoadingExcluirTodos: false,
      blLoadingAdicionar: false,
      blLoadingFiltrar: false,
      libera_carregamento: true,
      idUsuario: 1,
      linkUpgrade: "",
      produtosLength: 0,
      empresaSelecionada: {
        id: 0,
        nome: "Selecione uma empresa",
        cnpj: ""
      },
      paginacao: [],
      listarPaginas: [],
      blockPage: 0,
      blocks: 0,
      listGrid: [10, 20, 30, 40, 50],
      typeTimeout: null,
      doneTypingInterval: 1000,
      previousAction: "",
      blConfirmImport: false,
      blShowConfirmModal: false,
      confirmModalData: { title: "", message: "" },
      blResultadoImportacao: false,
      resultadoImportacao: {},
      blStatusResultadoImportacao: false,
      paginaAtual: null,
      paginaFinal: null
    };
  },
  beforeDestroy() {
    this.setBlBigData(false);
  },
  mounted: function() {
    // this.corrigeSelecaoEmpresa();

    let testAssinatura = localStorage.getItem("assinatura");
    if (
      testAssinatura &&
      testAssinatura !== undefined &&
      testAssinatura !== "undefined" &&
      testAssinatura != null
    ) {
      var dadosAssinatura = JSON.parse(localStorage.getItem("assinatura"));
      this.assinatura_id = this.getAssinatura.id;
      this.assinatura_plano = this.getAssinatura.nome_plano;
      this.assinatura_qtde_produto = parseInt(this.getAssinatura.qtde_produto);

      if (this.getAssinatura.qtde_pesquisa_ncm) {
        this.qtde_produto_cenario = parseInt(this.getAssinatura.qtde_pesquisa_ncm);
      }

      if (typeof this.assinatura_qtde_produto == "undefined") {
        this.assinatura_qtde_produto = 10;
      }
    }
    // if (typeof this.$props.empresa.erro === 'undefined') {
    // if (this.empresaSelecionada.erro === 'undefined') {
    // if (this.$props.empresa) {
    if (this.getEmpresa.id > 0) {
      this.listarProdutos(1);
    }
    // }
    this.carregarUsuario();
    this.quantidadeProdutos();
  },
  computed: {
    ...mapGetters("empresa", {
      getEmpresa: "getEmpresa"
    }),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    // blUsuarioPro() {
    //   return true
    // },
    ...mapGetters("login", {
      getAssinatura: "getAssinatura"
    }),
    existeEx() {
      if (this.exOptions.length > 0) {
        return false;
      }
      return true;
    },
    existeCest() {
      if (this.cestOptions.length > 1) {
        return false;
      }
      return true;
    },
    mensagemTooltip() {
      if (!this.getEmpresa.id) {
        return "Selecione uma empresa";
      } else if (!this.produtos.some(p => p.blChecked == true)) {
        return "Selecione um produto";
      } else if (this.produtos.some(p => p.blChecked == true && p.ncm.length == 12)) {
        return "Não é possível monitorar produtos com NBM";
      } else {
        return "";
      }
    },
    filteredProdutos: function() {
      if (this.strPesquisa == "") return this.produtos;
      else {
        return this.produtos.filter(p => {
          if (
            p.nome.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1 ||
            p.codigo_produto.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1 ||
            p.ncm.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1 ||
            p.ncm
              .toLowerCase()
              .replace(/\./g, "")
              .indexOf(this.strPesquisa.toLowerCase().replace(/\./g, "")) > -1 ||
            p.ean.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1 ||
            p.destinacao.destinacao.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1 ||
            p.fabricante.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1 ||
            p.marca.toLowerCase().indexOf(this.strPesquisa.toLowerCase()) > -1
          )
            return true;
        });
      }
    }
  },
  watch: {
    blLoadingButton() {
      this.setBlBigData(this.blLoadingButton);
    },
    strPesquisa() {
      this.btnFiltrarProdutos();
    },
    produtos() {
      this.produtos.forEach((e, i) => {
        this.produtos[i].ean = this.produtos[i].ean ? this.produtos[i].ean : "";
      });
      this.produtosFiltrados = this.produtos;
    },
    termo: function(newVal) {
      if (this.termo.length == 8) {
        this.getCest();
      } else {
        this.cestOptions = ["-"];
        this.cest = "-";
      }
      this.nav_termo = "";
      this.produto.ncm = this.termo;
      let re = /[\¹\²\³\=\:\¬\¢\£\'\"\@\!\#\$\.\#\&\%\+\§\/\|\;\¨]/gi;
      this.$set(this, "termo", newVal.replace(re, ""));
    },
    listaNcm() {
      if (this.listaNcm.length == 1 && this.termo.length == 8) {
        if (this.listaNcm[0].exTipi.length > 0) {
          this.exOptions = [];
          this.listaNcm[0].exTipi.map(p => {
            if (p.exPai) {
              return this.exOptions.push("-");
            }
            return this.exOptions.push(p.ex);
          });
        } else {
          this.exOptions = [];
        }
      } else {
        this.exOptions = [];
        this.ex = "-";
      }
    },
    produto: {
      deep: true,
      handler() {
        this.ex = this.produto.ex;
        this.cest = this.produto.cest;
      }
    },
    ex() {
      this.produto.ex = this.ex;
    },
    cest() {
      this.produto.cest = this.cest;
    },
    getEmpresa: function(newVal, oldVal) {
      if (newVal !== undefined) {
        // this.empresaSelecionada = newVal;
        this.listarProdutos(1);
        this.strPesquisa = "";
      }

      // if (newVal.cnpj != oldVal.cnpj) {

      // }
    },
    arNcmProdutos: {
      handler() {
        localStorage.setItem("arNcmProdutos", JSON.stringify(this.arNcmProdutos));
        this.verificarLSIsNull("arNcmProdutos");
      },
      deep: true
    },
    qtdeNcmsBuscados: function() {
      if (this.qtdeNcmsBuscados == this.qtdeSelecaoCenario && this.qtdeNcmsBuscados > 0) {
        this.$router.push("/cenario");
      }
    },
    file: function() {
      if (this.file && typeof this.file.name !== "undefined" && this.file.name != null) {
        let blName = this.file.name.indexOf(".xlsx");
        if (blName > -1) {
          this.arquivoValido = true;
          this.retornoArquivo = "";
          this.msgs = [];
        } else {
          this.arquivoValido = false;
          this.retornoArquivo =
            "<div class='alert alert-danger'>A extensão do arquivo é inválida. <br>Apenas '.xlsx' são permitidos.<div>";
        }
      }
    },
    quantidadeGrid: function() {
      //this.listarProdutos(this.paginacao.page);
      this.listarProdutos(1);
    }
  },

  methods: {
    ...mapActions("loading", ["setBlBigData"]),
    ...mapActions("listaNcm", ["setArNcmSelecionados"]),
    ...mapActions("login", {
      obterAssinatura: "obterAssinatura"
    }),
    ...mapActions("pesquisaNcm", ["fetchPesquisaMtrz"]),
    limparFiltro() {
      this.strPesquisa = "";
      this.$nextTick(() => {
        this.$refs.produtosInput.focus();
      });
    },
    abreModalCompreende() {
      this.$root.$emit("bv::show::modal", "ModalCompreende");
    },
    abreModalVigente(conteudo) {
      this.conteudoModalVigente = conteudo;
      this.$root.$emit("bv::show::modal", "ModalVigente");
    },
    alteraConteudo(conteudo) {
      this.produtosFiltrados = conteudo;
    },
    async getCest() {
      let ncmCest =
        this.termo.substring(0, 4) +
        "." +
        this.termo.substring(4, 6) +
        "." +
        this.termo.substring(6, 8);
      const { dados } = await new Api().post("Ncm/obterCestRelacionados", { ncm: ncmCest });
      this.cestOptions = ["-", ...dados];
    },
    autocomplete_produto: async function() {
      const response = await this.fetchPesquisaMtrz({
        valorPesquisa: this.termo,
        referencia: "NCM",
        autoComplete: "S",
        limite: 10,
        page: 1,
        ordenacao: "ASC"
      });
      if (response.data) {
        this.listaNcm = response.data.filter(p => p.vigente == 1);
      } else {
        this.listaNcm = [];
      }
    },
    handle_autocomplete_produto(resp) {
      this.termo = resp.ncm;
      this.$nextTick(() => {
        this.autocomplete_produto();
      });
    },
    // corrigeSelecaoEmpresa: function() {
    //   let emp = null;

    //   if (this.empresa !== undefined) {
    //     emp = this.empresa;
    //   } else if (this.$props.empresa !== undefined) {
    //     emp = this.$props.empresa;
    //   } else if (this.$parent.empresa !== undefined) {
    //     emp = this.$parent.empresa;
    //   }

    //   if (emp === undefined || emp == null) {
    //     this.empresaSelecionada = this.retornaEmpresaLocalStorage();

    //     if (this.empresaSelecionada == null) {
    //       this.empresaSelecionada = {
    //         id: 0,
    //         nome: "Selecione uma empresa",
    //         cnpj: ""
    //       };
    //     }
    //   } else {
    //     this.empresaSelecionada = emp;
    //   }
    // },
    abrirModalImportar() {
      this.$root.$emit("bv::show::modal", "ModalImportacao");
    },
    mostra_mensagem: function(mensagem) {
      if (mensagem == "") {
        $(".mensagem_limite").fadeOut("fast");
        return;
      }

      $(".mensagem_limite").html(mensagem);
      $(".mensagem_limite").fadeIn("fast");
    },
    monitoriaProduto: function(prod) {
      localStorage.setItem("monitoria_id_produto", prod ? prod.id : -1);
      this.verificarLSIsNull("monitoria_id_produto");

      this.$router.push("/monitoria-produto");
    },
    async atualizaProdutos() {
      await this.listarProdutos(1);
    },
    listarProdutos: async function(page) {
      this.strPesquisa = "";
      if (this.strPesquisa != "") {
        this.filtrarProdutos(page);
        return false;
      }

      var that = this;
      this.produtos = [];
      this.blLoadingButton = true;
      this.paginacao = [];
      this.listarPaginas = [];
      this.blCheckAll = false;
      this.paginaAtual = page;
      await this.quantidadeProdutos();

      // if (typeof this.$props.empresa.id == 'undefined' || this.$props.empresa.id == 0) {
      if (this.getEmpresa.id === undefined || this.getEmpresa.id == 0) {
        that.blLoadingButton = false;
        return false;
      }

      if (this.getEmpresa.id == null || this.getEmpresa.id == 0) {
        that.blLoadingButton = false;
        that.filteredProdutos = [];
        that.blLoadingButton = false;
        return false;
      }

      // new Api().get('Produto/obterProdutos/' + this.$props.empresa.id).then(response => {
      // new Api().get('Produto/obterProdutos/' + this.empresaSelecionada.id + '/' + this.quantidadeGrid + '/' + page).then(response => {
      // new Api().get('Produto/listarProdutos/' + this.empresaSelecionada.id + '/' + this.quantidadeGrid + '/' + page).then(response => {

      await new Api()
        .post("Produto/filtrarProdutos", {
          termo: "",
          origem: "p",
          empresa: this.getEmpresa.id,
          limite: 2000,
          pagina: 1
        })
        .then(response => {
          that.produtos = response.dados;
          that.paginaAtual = response.mensagem.page;
          that.paginaFinal = response.mensagem.pages;

          if (typeof response.mensagem == "object") {
            that.paginacao = response.mensagem;
            that.listarPaginas = that.paginacao.listPages;
            that.blocks = that.paginacao.blocks;
            if (that.paginacao.blocks == 0) {
              that.blockPage = 0;
            }
          }

          that.produtos = that.produtos.filter(p => {
            if (typeof p.destinacao[0] !== "undefined") p.destinacao = p.destinacao[0];
            return true;
          });

          that.blLoadingButton = false;
          if (that.produtos.length <= 10 && that.previousAction == "D") {
            that.quantidadeGrid = 10;
            that.previousAction = "";
          }
          this.listarDestinacao();
        })
        .finally(() => {
          if (this.$router.history.current.name == "addProdutos") {
            this.adicionarProduto();
          }
        })
        .catch(response => {
          if (response.status == undefined) {
            that.blLoadingButton = false;
            that.filteredProdutos = [];
            that.blLoadingButton = false;
            // this.mostra_mensagem('Erro ao carregar Produtos')
          }
        });
      this.strOrdem = "";
    },
    listarDestinacao: function() {
      var that = this;
      this.options_destinacao = [];

      new Api().get("Produto/obterDestinacao").then(response => {
        this.options_destinacao = response.dados;

        // $.each(this.produtos,function(index,element){
        // 	new Api()
        // 	.post('Ncm/pesquisaNcm', { termo: element.ncm, tipo: 'NCM', palavra: 0, autocomplete: 'N', count: 'N' })
        // 	.then(response => {
        // 		that.produtos[index].pesquisa = response.dados[0];
        // 		//that.arNcmProdutos.push(response.dados[0]);
        // 		//that.qtdeNcmsBuscados++;
        // 	});
        // });
      });
    },
    ordenar: function(strOrdem) {
      if (strOrdem == this.strOrdem) {
        this.reverse = !this.reverse;
        this.produtosFiltrados.reverse();
        return;
      }
      this.reverse = false;
      if (strOrdem == "destinacao") {
        this.produtosFiltrados.sort((a, b) => {
          return a.destinacao.id_produto_destinacao.localeCompare(
            b.destinacao.id_produto_destinacao
          );
        });
      } else {
        this.produtosFiltrados.sort((a, b) => {
          if (
            a[strOrdem] == "-" ||
            a[strOrdem] == "" ||
            a[strOrdem] == "0" ||
            b[strOrdem] == "-" ||
            b[strOrdem] == "" ||
            b[strOrdem] == "0"
          ) {
            return a[strOrdem] == "-" || a[strOrdem] == "" || a[strOrdem] == "0" ? 1 : -1;
          }
          return a[strOrdem].localeCompare(b[strOrdem]);
        });
      }

      this.strOrdem = strOrdem;
    },
    alertasQuantidade: function() {
      this.mostra_mensagem("");
      if (!this.produtosLength) return true;
      if (this.getAssinatura.qtde_produto > this.produtosLength) return true;

      if (this.assinatura_plano == "Premium 01") {
        this.mostra_mensagem(
          "Limite de produtos atingido para a versão " +
            this.assinatura_plano +
            " do sistema RTE. Verifique e adquira outra versão Premium que atenda sua necessidade!"
        );
        this.pushAlert(
          "Deseja importar mais produtos? Verifique e adquira outra versão Premium que atenda sua necessidade.",
          "primary"
        );
      } else if (this.assinatura_plano == "Premium 02" || this.assinatura_plano == "Premium 03") {
        this.mostra_mensagem(
          "Limite de produtos atingido para a versão " +
            this.assinatura_plano +
            " do sistema RTE. Atualize o seu pacote premium!"
        );
        this.pushAlert("Deseja importar mais produtos? Atualize o seu pacote premium.", "primary");
      } else if (this.assinatura_plano == "Premium 04") {
        this.mostra_mensagem(
          "Limite de produtos atingido para a versão " +
            this.assinatura_plano +
            " do sistema RTE. Contrate o serviço de assessoria para monitorar mais produtos."
        );
        this.pushAlert(
          "Limite de cadastro máximo de produtos atingido. Contrate o serviço de assessoria para monitorar mais produtos.",
          "primary"
        );
      } else {
        this.mostra_mensagem(
          "Limite de produtos atingido. Contrate o serviço de assessoria para monitorar mais produtos."
        );
        this.pushAlert(
          "Limite de cadastro máximo de produtos atingido. Contrate o serviço de assessoria para monitorar mais produtos.",
          "primary"
        );
      }

      return false;
    },
    adicionarProduto: async function() {
      let emp = this.retornaEmpresaLocalStorage();

      if (!this.getAssinatura.qtde_produto) {
        this.blLoadingAdicionar = true;

        if (this.getAssinatura == {}) {
          await this.obterAssinatura();
        }

        this.blLoadingAdicionar = false;
      }

      const alertasQuantidade = this.alertasQuantidade();

      if (
        (this.getAssinatura.qtde_produto <= this.produtoLength && this.produtosLength > 0) ||
        this.acesso_simulado ||
        // this.$parent.empresa.id == 0 ||
        this.getEmpresa.id == 0 ||
        emp == null ||
        this.blLoadingButton
      ) {
        if (emp == null || typeof emp.id == "undefined" || emp.id == 0) {
          this.$refs.modalSelecioneEmpresa.show();
          return false;
        }
      }

      if (!alertasQuantidade) return false;

      this.titleModal = "Adicionar";
      this.resetFields();
      this.$refs.modalCadastro.show();
    },
    adicionarProdutoModal() {
      if (!this.getEmpresa.id || this.getEmpresa.id == "") {
        this.pushAlert("Selecione uma Empresa para adicionar produtos", "warning");
        return;
      }

      this.tituloModalProduto = "adicionar";
      this.editarProdutoData = null;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    editarProdutoModal(prod) {
      this.tituloModalProduto = "editar";
      this.editarProdutoData = prod;
      this.atualizaModal = !this.atualizaModal;
      this.$root.$emit("bv::show::modal", "ModalProduto");
    },
    editarProduto: function(prod, index) {
      this.titleModal = "Editar";
      this.produto = Object.assign({}, prod);
      this.produto.index = index;
      this.termo = this.produto.ncm;
      this.$nextTick(() => {
        this.autocomplete_produto();
      });

      this.selected_destinacao = [
        {
          value: prod.destinacao.id_produto_destinacao,
          label: prod.destinacao.cod_destinacao + " - " + prod.destinacao.destinacao
        }
      ];

      this.produto.ex = this.produto.ex != null && this.produto.ex > 0 ? this.produto.ex : "-";
      this.produto.cest =
        this.produto.cest != null && this.produto.cest != 0 ? this.produto.cest : "-";

      this.normalizeFieldsFront();
      this.$refs.modalCadastro.show();
    },
    excluirProduto: function(prod) {
      if (this.blUsuarioPro) {
        this.pushAlert("Opção desabilitada na versão de testes", "danger");
        return;
      }
      this.dadosProdutoDelete = prod;
      this.$root.$emit("bv::show::modal", "ModalExcluirProduto");

      // $(".mensagem_limite").fadeOut("fast");
      // this.arProdutoExcluir = [];
      // this.arProdutoExcluir.push(prod);

      // this.$refs.modalExcluir.show();
    },
    excluirLote: function() {
      this.produto.editarLote = false;
      this.blChangeAll = false;
      this.arProdutoExcluir = this.produtosFiltrados.filter(p => {
        return p.selecionado == true;
      });

      $(".mensagem_limite").fadeOut("fast");
      this.$refs.modalExcluir.show();
      // this.$root.$emit("bv::show::modal", "ModalExcluirProduto");
    },
    onClickExcluir: function(blTodos = false) {
      let obj = {};
      let that = this;
      let prodExcluir = [];
      this.arProdutoExcluir.filter(e => {
        prodExcluir.push({
          id: e.id
        });
      });

      if (blTodos) {
        this.blLoadingExcluirTodos = true;
      } else {
        this.blLoadingExcluir = true;
      }

      new Api()
        .post("Produto/excluirProdutos", {
          produtos: prodExcluir,
          blTodos: blTodos,
          idEmpresa: this.getEmpresa.id
        })
        .then(response => {
          let idUnico = null;
          let arIds = this.arProdutoExcluir.map(p => {
            idUnico = p.id;
            return p.id;
          });
          this.produtos = this.produtos.filter(p => {
            return !arIds.includes(p.id);
          });

          this.$refs.modalExcluir.hide();
          that.blCheckAll = false;

          // that.quantidadeProdutos();
          that.pushAlert("Produto(s) excluído(s) com sucesso!", "success");
          that.blLoadingExcluir = false;
          that.blLoadingExcluirTodos = false;

          that.previousAction = "D";
          that.listarProdutos(1);
        });
    },
    clearInput() {
      this.produto.ex = "-";
      this.produto.cest = "-";
      this.cest = "-";
      this.ex = "-";
    },
    limparMarcacao(id) {
      let chars = $(id).val();
      let len = chars.trim();
      if (len.length > 0) {
        $(id).removeClass("required");
      }
    },
    validaNCM(valida) {
      if (!valida) {
        this.bypassNCM = true;
        this.onClickSalvar();
      }
      this.$refs.ncmInvalida.hide();
    },
    onClickSalvar: async function() {
      let obj = {};
      this.normalizeFieldsBack();
      let textNome = "";
      let that = this;
      if (!this.produto.editarLote) {
        textNome = this.produto.nome.trim();
        let prod = this.produto;

        //NCM
        if (prod.ncm.length < 2) {
          this.pushAlert("Campo obrigatório", "danger");
          $("#ncm_produto").focus();
          $("#ncm_produto").addClass("required");
          return;
        }
        if (prod.ncm.length < 8) {
          this.pushAlert(
            "O código NCM informado não contém a quantidade de dígitos válido. Insira uma NCM válida.",
            "danger"
          );
          $("#ncm_produto").focus();
          $("#ncm_produto").addClass("required");
          return;
        }
        if (this.produto.ncm.length < 8 && !this.bypassNCM) {
          $("#ncm_produto").focus();
          $("#ncm_produto").addClass("required");
          this.$refs.ncmInvalida.show();
          return;
        }
        $("#ncm_produto").removeClass("required");

        //Nome Produto
        if (!this.produto.nome || textNome.length == 0) {
          this.pushAlert("Campo obrigatório", "danger");
          $("#nome_produto").focus();
          $("#nome_produto").addClass("required");
          return;
        }

        //Destinaçao
        if (this.titleModal == "Adicionar" && !this.selected_destinacao.value) {
          this.pushAlert("Campo obrigatório", "danger");
          $("#destinacao").addClass("required");
          $("#destinacao").focus();
          return;
        }

        //EX
        // if (this.produto.ex != "" && this.produto.ex < 0) {
        // 	this.pushAlert('Informe um EX válido', 'danger');
        // 	$('#ex').addClass('required');
        // 	$('#ex').focus();
        // 	return;
        // }
        // if (this.produto.ex > 5) {
        // 	this.pushAlert('Informe um EX menor ou igual a 5 ou deixe o campo vazio', 'danger');
        // 	$('#ex').addClass('required');
        // 	$('#ex').focus();
        // 	return;
        // }

        if (this.produto.ean != "" && this.produto.ean != "-") {
          this.produto.ean = this.produto.ean ? this.produto.ean : "";
          if (
            this.produto.ean.length != 0 &&
            this.produto.ean.length != 8 &&
            this.produto.ean.length != 12 &&
            this.produto.ean.length != 13 &&
            this.produto.ean.length != 14
          ) {
            this.pushAlert("Código EAN inválido", "danger");
            $("#ean_produto").focus();
            return;
          }
        }

        if (this.filteredProdutos.length > 0) {
          let error = false;
          let complemento = "";

          this.filteredProdutos.map(item => {
            if (
              ((item.codigo_produto != "" &&
                item.codigo_produto != "-" &&
                item.ncm + item.ex + item.nome + item.codigo_produto ==
                  this.produto.ncm +
                    this.produto.ex +
                    this.produto.nome +
                    this.produto.codigo_produto) ||
                item.ncm + item.ex + item.nome ==
                  this.produto.ncm + this.produto.ex + this.produto.nome) &&
              this.produto.id != item.id
            ) {
              if (
                item.ncm + item.ex + item.nome ==
                this.produto.ncm + this.produto.ex + this.produto.nome
              ) {
                complemento = "(NCM + EX + Nome do Produto)";
              }

              if (item.codigo_produto != "" && item.codigo_produto != "-") {
                if (
                  item.ncm + item.ex + item.nome + item.codigo_produto ==
                  this.produto.ncm +
                    this.produto.ex +
                    this.produto.nome +
                    this.produto.codigo_produto
                ) {
                  complemento = "(NCM + EX + Nome do Produto + Código do Produto)";
                }
              }
              // if ((item.ncm + item.ex) == (this.produto.ncm + this.produto.ex))
              // 	complemento = "(NCM + EX)";
              // if (item.nome == this.produto.nome)
              //  	complemento = "(Nome do Produto)";
              // if (item.codigo_produto != '' && item.codigo_produto != '-' && this.produto.codigo_produto == item.codigo_produto)
              // 	complemento = "(Código do Produto)";
              error = true;
              return;
            }
          });

          if (error) {
            this.pushAlert("Este produto já foi cadastrado " + complemento, "danger");
            return;
          }
        }

        this.produto.nome = textNome;
        let formatNcm = this.produto.ncm.split(".").join("");
        formatNcm = `${formatNcm.substring(0, 4)}.${formatNcm.substring(
          4,
          6
        )}.${formatNcm.substring(6, 10)}`;
        if (this.produto.ncm.length >= 8) this.produto.ncm = formatNcm;
      }

      // this.produto.id_empresa = this.$props.empresa.id;
      this.produto.id_empresa = this.getEmpresa.id;
      this.produto.id_destinacao = this.selected_destinacao.value;

      this.produto.ex = this.produto.ex == "-" || this.produto.ex == "" ? 0 : this.produto.ex;
      this.produto.cest =
        this.produto.cest == "-" || this.produto.cest == "" ? 0 : this.produto.cest;

      if (this.produto.editarLote) {
        that.blLoadingSalvar = true;
        new Api().post("Produto/alterarProduto/0", this.produto).then(response => {
          var dados = response.dados;

          if (typeof dados.erro === "undefined") {
            dados = dados.filter(p => {
              if (typeof p.destinacao[0] !== "undefined") p.destinacao = p.destinacao[0];
              return true;
            });
            for (let i = 0; i < dados.length; i++) {
              let prodTribMonitoria = {
                ...this.produtos[dados[i].ordem],
                id: dados[i].id
              };

              this.produtos[dados[i].ordem].monitoria = dados[i].monitoria;
              this.produtos[dados[i].ordem].icms_estado = dados[i].icms_estado;
              this.produtos[dados[i].ordem].destinacao = dados[i].destinacao;

              new Api().post("Produto/inserirProdutoMonitoria", prodTribMonitoria);
            }
          }

          that.alertas.push({
            msg: "Atualizado com sucesso",
            class: "success",
            blShow: true
          });
          that.blLoadingSalvar = false;
          that.produto = [];
          that.closeModal();
        });
        return;
      }
      if (this.bypassNCM) {
        this.produto.sugestao = 0;
        this.bypassNCM = false;
      } else {
        if (this.produto.sugestao != 1) {
          this.produto.sugestao = 0;
        }
      }

      // Adicionar
      if (this.titleModal == "Adicionar") {
        this.blLoadingSalvar = true;

        if (this.getAssinatura == {}) {
          await this.obterAssinatura();
        }

        const alertasQuantidade = this.alertasQuantidade();
        if (!alertasQuantidade) {
          this.blLoadingSalvar = false;
          return false;
        }

        new Api().post("Produto/inserirProduto", this.produto).then(response => {
          if (typeof response.erro !== "undefined") {
            if (response.erro == "Undefined index: arTributos") {
              that.pushAlert("Produto Cadastrado com sucesso!", "success");
            }
          }

          that.blLoadingSalvar = false;

          if (!response.status) {
            if (response.mensagem == "duplicado") {
              that.pushAlert("Atenção! Você já possuí este produto cadastrado.", "danger");
            } else if (response.mensagem == "ncm_inexistente") {
              that.pushAlert(
                "O código " +
                  that.produto.ncm +
                  " informado é inexistente. Verifique se foi digitado corretamente.",
                "danger"
              );
            } else if (response.mensagem == "ex_inexistente") {
              that.pushAlert(
                "Não localizamos o código " +
                  that.produto.ncm +
                  " com o EX " +
                  that.produto.ex +
                  ". Verifique se o EX foi digitado corretamente ou se ainda esta vigente.",
                "danger"
              );
            } else {
              that.pushAlert("Falha ao adicionar produto", "danger");
            }

            $("#ncm_produto").focus();
            return;
          } else {
            that.pushAlert("Produto Cadastrado com sucesso!", "success");

            const prodTribMonitoria = {
              ...that.produto,
              id: response.dados.id
            };

            new Api().post("Produto/inserirProdutoMonitoria", prodTribMonitoria);
          }
          that.resetFields();
          that.listarProdutos(1);
          //this.closeModal();
          this.alertas = [];
          this.alertas.push({
            msg: "Cadastrado com sucesso",
            class: "success",
            blShow: true
          });
          // that.quantidadeProdutos();
          that.closeModal();
        });
        if (this.$router.history.current.name == "addProdutos") {
          this.$router.push("/produtos");
        }
      } else if (this.titleModal == "Editar") {
        this.produto.ex = this.produto.ex == "-" || this.produto.ex == "" ? 0 : this.produto.ex;
        this.blLoadingSalvar = true;

        new Api().post("Produto/alterarProduto/" + this.produto.id, this.produto).then(response => {
          let produto = response.dados;
          //this.$set(this.produtos, this.produto.index, produto);
          that.blLoadingSalvar = false;

          if (!response.status) {
            if (response.mensagem == "duplicado") {
              that.pushAlert("Atenção! Você já possuí este produto cadastrado.", "danger");
            } else if (response.mensagem == "ncm_inexistente") {
              that.pushAlert(
                "O código " +
                  that.produto.ncm +
                  " informado é inexistente. Verifique se foi digitado corretamente.",
                "danger"
              );
            } else if (response.mensagem == "ex_inexistente") {
              that.pushAlert(
                "Não localizamos o código " +
                  that.produto.ncm +
                  " com o EX " +
                  that.produto.ex +
                  ". Verifique se o EX foi digitado corretamente ou se ainda esta vigente.",
                "danger"
              );
            } else {
              that.pushAlert("Falha ao adicionar produto", "danger");
            }

            $("#ncm_produto").focus();
            return;
          }
          new Api().post("Produto/inserirProdutoMonitoria", this.produto);

          if (typeof produto.destinacao[0] !== "undefined")
            produto.destinacao = produto.destinacao[0];

          this.produtos[this.produto.index].monitoria = produto.monitoria;
          this.produtos[this.produto.index].icms_estado = produto.icms_estado;
          this.produtos[this.produto.index].destinacao = produto.destinacao;

          this.produto = [];

          that.resetFields();
          that.listarProdutos(1);
          that.closeModal();

          this.alertas = [];
          this.alertas.push({
            msg: "Atualizado com sucesso",
            class: "success",
            blShow: true
          });
          that.blLoadingSalvar = false;
        });
      }
    },
    resetFields: function() {
      this.produto = [];
      this.produto.id_empresa = "";
      this.produto.codigo_produto = "";
      this.produto.id = "";
      this.produto.ex = "-";
      this.produto.cest = "-";
      this.produto.ncm = "";
      this.termo = "";
      this.exOptions = [];
      this.ex = "";
      this.cest = "-";
      this.keyNcm++;
      this.produto.nome = "";
      this.produto.fabricante = "";
      this.produto.marca = "";
      this.produto.ean = "";
      this.produto.destinacao = [];
      this.produto.icms = false;
      this.produto.piscofins = false;
      this.produto.ipi = false;
      this.produto.ii = false;
      this.produto.ie = false;
      this.produto.piscofins_i = false;
      this.produto.cide = false;
      this.produto.defesa = false;
      this.produto.icms_estado = [];
      this.selected_destinacao = [
        {
          value: "",
          label: "Selecione uma Destinação"
        }
      ];
      this.keyTributos = new Date().getTime();
    },
    normalizeFieldsBack: function() {
      this.produto.icms = this.produto.icms == true || this.produto.icms == 1 ? 1 : 0;
      this.produto.piscofins =
        this.produto.piscofins == true || this.produto.piscofins == 1 ? 1 : 0;
      this.produto.ipi = this.produto.ipi == true || this.produto.ipi == 1 ? 1 : 0;
      this.produto.ii = this.produto.ii == true || this.produto.ii == 1 ? 1 : 0;
      this.produto.ie = this.produto.ie == true || this.produto.ie == 1 ? 1 : 0;
      this.produto.piscofins_i =
        this.produto.piscofins_i == true || this.produto.piscofins_i == 1 ? 1 : 0;
      this.produto.cide = this.produto.cide == true || this.produto.cide == 1 ? 1 : 0;
      this.produto.defesa = this.produto.defesa == true || this.produto.defesa == 1 ? 1 : 0;
    },
    normalizeFieldsFront: function() {
      this.produto.icms = this.produto.icms == true || this.produto.icms == 1 ? true : false;
      this.produto.piscofins =
        this.produto.piscofins == true || this.produto.piscofins == 1 ? true : false;
      this.produto.ipi = this.produto.ipi == true || this.produto.ipi == 1 ? true : false;
      this.produto.ii = this.produto.ii == true || this.produto.ii == 1 ? true : false;
      this.produto.ie = this.produto.ie == true || this.produto.ie == 1 ? true : false;
      this.produto.piscofins_i =
        this.produto.piscofins_i == true || this.produto.piscofins_i == 1 ? true : false;
      this.produto.cide = this.produto.cide == true || this.produto.cide == 1 ? true : false;
      this.produto.defesa = this.produto.defesa == true || this.produto.defesa == 1 ? true : false;
    },
    checkAll: function() {
      let alterados = [];

      this.produtos.forEach(p => {
        p.selecionado = this.blCheckAll;
        alterados.push(p);
      });
    },
    onPaginateChange: function(toPage, fromPage) {
      this.blCheckAll = false;
      let count = 0;
      let nCount = 0;
      let min = 0;
      let max = 0;

      this.filteredProdutos.forEach(p => {
        count++;
        min = parseInt(toPage) * parseInt(this.quantidadeGrid);
        max = parseInt(toPage) * parseInt(this.quantidadeGrid) + parseInt(this.quantidadeGrid);

        if (count > min && count <= max) {
          if (p.selecionado == true) {
            nCount++;
          }
        }
      });

      if (nCount == this.quantidadeGrid) this.blCheckAll = true;
      else this.blCheckAll = false;
    },
    closeModal: function() {
      this.blChangeAll = false;
      this.arProdutoEditar = [];
      this.produto.editarLote = false;
      this.$refs.modalCadastro.hide();
      this.resetFields();
      if (this.$router.history.current.name == "addProdutos") {
        this.$router.push("/produtos");
      }
    },
    closeModalImportar: function() {
      this.$refs.modalImportar.hide();
      this.retornoArquivo = "";
      this.msgs = [];
    },
    closeModalExcluir: function() {
      this.arProdutoExcluir = [];
      this.$refs.modalExcluir.hide();
    },
    closeModalSelecineEmpresa: function() {
      this.$refs.modalSelecioneEmpresa.hide();
    },
    importarProduto: async function() {
      this.blLoadingImportar = true;
      this.retornoArquivo = "";
      this.blResultadoImportacao = false;
      this.resultadoImportacao = {};

      if (this.getAssinatura == {}) {
        await this.obterAssinatura();
      }

      this.blLoadingImportar = false;

      this.quantidadeProdutos();
      let emp = this.retornaEmpresaLocalStorage();
      const alertasQuantidade = this.alertasQuantidade();

      if (
        (this.getAssinatura.qtde_produto <= this.produtosLength && this.produtosLength > 0) ||
        this.acesso_simulado ||
        // this.$parent.empresa.id == 0 ||
        this.getEmpresa.id == 0 ||
        emp == null ||
        this.blLoadingButton
      ) {
        if (emp == null || typeof emp.id == "undefined" || emp.id == 0) {
          this.$refs.modalSelecioneEmpresa.show();
          return false;
        }

        return false;
      }

      var limite = 0;

      let testAssinatura = localStorage.getItem("assinatura");
      if (
        testAssinatura &&
        testAssinatura !== undefined &&
        testAssinatura !== "undefined" &&
        testAssinatura != null
      )
        this.assinatura = JSON.parse(localStorage.getItem("assinatura"));

      limite = parseInt(this.getAssinatura.qtde_produto) - parseInt(this.produtosLength);
      if (limite <= 0) {
        if (!alertasQuantidade) return false;
      } else {
        this.produto.editarLote = false;
        this.blChangeAll = false;
        this.$refs.modalImportar.show();
      }
    },
    exibeModalConfirmaImportacao: function(dados) {
      // alert(dados.message);
      (this.confirmModalData = {
        title: "Importação de Produtos",
        message: dados.message
      }),
        (this.blShowConfirmModal = true);
    },
    confirmModalConfirm: function() {
      this.blConfirmImport = true;
      this.blShowConfirmModal = false;
      this.onClickImportar();
    },
    cancelModalConfirm: function() {
      this.blShowConfirmModal = false;
      this.$refs.fileinput.reset();
      this.blLoadingImportar = false;
    },
    onClickImportar: function() {
      var that = this;

      this.retornoArquivo = "";
      this.blResultadoImportacao = false;
      this.resultadoImportacao = {};

      if (this.file != "" && typeof this.file !== "undefined" && this.file != null) {
        this.blLoadingImportar = true;
        this.arquivoValido = true;

        let form = new FormData();
        form.append("arquivo", this.file);
        form.append("idEmpresa", this.getEmpresa.id);

        new ApiImportador()
          .file("/importador/importarProdutosRTE", form)
          .then(response => {
            that.resultadoImportacao = response.response;
            that.blStatusResultadoImportacao = response.status;

            that.$refs.fileinput.reset();
            that.blLoadingImportar = false;
            that.blResultadoImportacao = true;

            that.listarProdutos(1);
          })
          .then(() => {
            // that.quantidadeProdutos();
          });
      } else {
        this.arquivoValido = false;
        this.retornoArquivo = "<div class='alert alert-danger'>Selecione um arquivo!<div>";
      }
    },
    criarCenario: function() {
      let arProdutos = this.produtosFiltrados.filter(p => {
        return p.selecionado == true;
      });

      // let countImpedidos = 0;
      // let ncmImpedidas = [];
      // let arProdutosImpedidos = arProdutos.filter(p => {
      //   if (
      //     p.selecionado == true &&
      //     p.sugestao == "0" &&
      //     (p.vigente == 0 || p.alterado == 1 || p.tipo == "incompleto")
      //   ) {
      //     countImpedidos++;
      //     ncmImpedidas.push(p.ncm);
      //     return true;
      //   }
      // });
      // if (countImpedidos > 0) {
      //   this.pushAlert(
      //     "Não é possível criar cenário com uma NCM não vigente. NCM impossibilitadas: " +
      //       ncmImpedidas.join(", "),
      //     "danger"
      //   );
      //   return false;
      // }

      if (arProdutos.length > this.qtde_produto_cenario) {
        this.pushAlert(
          "Só é possível criar cenário com até " + this.qtde_produto_cenario + " produtos.",
          "danger"
        );
        return false;
      }

      var that = this;
      this.blLoadingButton = true;
      this.produto.editarLote = false;
      this.blChangeAll = false;
      if (arProdutos.length > 0) {
        $.each(arProdutos, function() {
          that.buscaNCMs(this.ncm, this.ex, this.nome);
        });
        this.setArNcmSelecionados(this.arNcmProdutos);
        this.qtdeSelecaoCenario = arProdutos.length;
      }
    },
    buscaNCMs: function(ncm, ex = 0, nome) {
      var that = this;
      this.arNcmProdutos = [];

      if (ncm != "") {
        new Api()
          .post("Ncm/pesquisaNcmMatriz", {
            valorPesquisa: ncm,
            referencia: "NCM",
            autoComplete: "N",
            limite: 10,
            page: 1,
            ordenacao: "ASC"
          })
          .then(response => {
            if (typeof response.data[0] !== "undefined") {
              response.data[0].nomeProduto = nome;
              response.data[0].ex = ex == "-" || ex == "" ? "0" : ex;
              that.arNcmProdutos.push(response.data[0]);
              that.qtdeNcmsBuscados++;
            }
          });
      }
    },
    alterarNcm: async function(idProduto, ncm, ex) {
      let that = this;
      let obj = {};
      await new Api()
        .post("Produto/alterarNcm/" + idProduto, {
          ncm: ncm,
          ex: ex
        })
        .then(response => {
          //that.listarProdutos();
          let produtos = this.produtos;

          produtos = produtos.map(produto => {
            if (produto.id === idProduto) {
              produto.sugestao = response.dados.sugestao;
            }
            return produto;
          });

          this.produtos = produtos;

          obj = {
            strUrl: "Produto/alterarNcm/",
            intIdItem: idProduto,
            strMetodoHttp: "POST",
            intIdFerramenta: 7,
            intIdTipoAcao: 3,
            strTipoAcao: "Editar",
            strObjetoClick: "Sugestão de NCM",
            strDestinoClick: ""
          };
          that.registraLogAcesso(obj);
          this.filtrarProdutos(this.paginaAtual);
        });
    },

    checkProdutoModal: function(prod) {
      this.prodSelecionado = prod;
      this.$refs.modalAlterar.show();
    },
    closeModalAlterar: function() {
      this.$refs.modalAlterar.hide();
    },
    aceitaNCM(status) {
      this.acceptSuggestion = false;
      if (status) {
        this.acceptSuggestion = true;
        this.checkProduto(this.dataProduct);
      }
      this.dataProduct = {};
      this.$refs.ncmSugestao.hide();
    },
    checkProduto: function(prod) {
      if (prod.tipo == "sugestao") {
        if (!this.acceptSuggestion) {
          if (prod.ex == null) {
            prod.ex = 0;
          }
          this.dataProduct = prod;
          this.$refs.ncmSugestao.show();
          return;
        }

        let produtoPai = this.produtos.find(p => p.exibeSugestoes == true);
        prod.id = produtoPai.id;
        var that = this;
        this.alterarNcm(prod.id, prod.ncm, prod.ex);

        var arProdutos = this.produtos.filter(p => {
          if (prod.tipo == "sugestao") {
            return p.exibeSugestoes == true;
          }
          return p.id == prod.id;
        });

        var arProdutosRemover = arProdutos.filter(p => {
          return p.tipo !== "nao-vigente" && p.tipo !== "alterado" && p.tipo !== "incompleto";
        });

        var idProd = prod.id;
        $.each(arProdutosRemover, function(index, element) {
          that.produtos.splice(that.produtos.indexOf(element), 1);
        });

        var myProd = arProdutos.filter(p => {
          return p.tipo == "nao-vigente" || p.tipo == "alterado" || p.tipo == "incompleto";
        });

        let indexProd = this.produtos.indexOf(myProd[0]);

        this.produtos[indexProd].ex = prod.ex ? prod.ex : 0;
        this.produtos[indexProd].vinculo = prod.vinculo ? prod.vinculo : null;
        this.produtos[indexProd].vigente = 1;
        this.produtos[indexProd].tipo = "normal";
        this.produtos[indexProd].ncm = prod.ncm;
        this.produtos[indexProd].sugestao = 1;
        this.produtos[indexProd].alterado = 0;
        this.produtos[indexProd].sugestoes = [];
        this.produtos[indexProd].mensagem = "undefined";
        this.produtos[indexProd].exibeSugestoes = false;
        this.acceptSuggestion = false;
        this.dataProduct = {};

        prod.exibeSugestoes = false;
      }

      let checkeds = 0;
      this.produtos.forEach(p => {
        if (p.selecionado) {
          checkeds++;
        }
      });

      this.blCheckAll = this.produtos.length != checkeds ? false : true;
    },
    textoLimitado: function(texto, limite) {
      if (texto.length > limite) return texto.substr(0, limite) + "..";
      return texto;
    },
    openMonitoria: function(produto) {
      localStorage.setItem("monitoria_id_produto", produto.id);
      this.verificarLSIsNull("monitoria_id_produto");

      this.$router.push({
        path: "/monitoria-produto"
      });
    },
    editarLoteModal() {
      this.tituloModalProduto = "editar-lote";
      this.loteLoading = true;
      setTimeout(async () => {
        await new Promise(resolve => {
          this.arProdutoEditar = this.produtosFiltrados.filter(p => p.selecionado);
          this.atualizaModal = !this.atualizaModal;
          resolve();
        });
        this.loteLoading = false;
        this.$root.$emit("bv::show::modal", "ModalProduto");
      }, 20);
    },
    editarLote: function() {
      this.titleModal = "Editar";
      let x = 0;
      this.produtos.map((p, i) => {
        if (p.selecionado == true) {
          this.arProdutoEditar[x] = p;
          this.arProdutoEditar[x].index = i;
          x++;
        }
      });
      if (this.arProdutoEditar.length == 1) {
        for (let i = 0; i < this.produtos.length; i++) {
          if (this.produtos[i].id == this.arProdutoEditar[0].id) {
            this.editarProduto(this.arProdutoEditar[0], i);
            this.blChangeAll = false;
            this.arProdutoEditar = [];
            this.produto.editarLote = false;
            break;
          }
        }
      } else {
        this.produto = this.arProdutoEditar;
        this.produto.editarLote = true;
        this.blChangeAll = true;
        this.$refs.modalCadastro.show();
      }
    },
    validaEX() {
      if (this.produto.ex) {
        if (this.produto.ex == 0) {
          document.getElementById("ex").value = "";
          this.produto.ex = "";
        }

        if (this.produto.ex > 11) {
          document.getElementById("ex").value = "11";
          this.produto.ex = 11;
        }
      }
    },
    // exibirSugestoes: async function(index, prod) {
    //   let prodTemp = prod;

    //   prod.exibeSugestoes = !prodTemp.exibeSugestoes;
    //   prod.blLoadingButton = true;

    //   if (prod.mensagem == "Sem sugestões de NCMs disponíveis. Verifique o código informado.") {
    //     prod.exibeSugestoes = false;
    //     this.pushAlert(
    //       "Sem sugestões de NCMs disponíveis. Verifique o código informado.",
    //       "danger"
    //     );
    //   }

    //   if (prod.mensagem == "Código do produto inexistente.") {
    //     prod.exibeSugestoes = false;
    //     this.pushAlert("Altere o NCM do produto " + prod.ncm);
    //   }

    //   this.produtos = this.produtos.map((produto, i) => {
    //     return index == i ? prod : produto;
    //   });

    //   if (prod.exibeSugestoes && (!prod.sugestoes || prod.sugestoes.length == 0)) {
    //     let response = await new Api().get(
    //       "Produto/obterSugestoes/" + this.empresaSelecionada.id + "/" + prod.id
    //     );

    //     if (!response) {
    //       prod.exibeSugestoes = false;

    //       this.produtos = this.produtos.map((produto, i) => {
    //         return index == i ? prod : produto;
    //       });
    //       return;
    //     }

    //     let ProdSugestoes = response.dados;

    //     prod.sugestoes = ProdSugestoes.sugestoes;

    //     prod.sugestoes.forEach(sug => {
    //       sug.selecionado = false;
    //       sug.tipo = "sugestao";
    //     });

    //     if (prod.sugestoes.length == 0) {
    //       this.pushAlert(
    //         "Sem sugestões de NCMs disponíveis. Verifique o código informado.",
    //         "danger"
    //       );
    //       prod.mensagem = "Sem sugestões de NCMs disponíveis. Verifique o código informado.";
    //       prod.exibeSugestoes = false;
    //     }

    //     this.produtos = this.produtos.map((produto, i) => {
    //       return index == i ? prod : produto;
    //     });
    //   }

    //   prod.blLoadingButton = false;
    // },
    retornaEmpresaLocalStorage: function() {
      let empresa = JSON.parse(localStorage.getItem("empresa"));

      if (empresa != null && typeof empresa.erro !== "undefined") {
        return null;
      }

      if (empresa != null && typeof empresa.id === "undefined") {
        return null;
      }

      return empresa;
    },
    carregarUsuario: function() {
      let that = this;
      new Api().get("Usuario/obterUsuario").then(response => {
        var dados = response.dados;
        that.idUsuario = dados.id_usuario;
        that.montaLinkUpgrade();
      });
    },
    montaLinkUpgrade: function() {
      let link = "https://carrinho.econeteditora.com.br/";
      this.linkUpgrade = link;
    },
    abreLinkUpgrade: function() {
      window.open(this.linkUpgrade, "_blank");
    },
    async quantidadeProdutos() {
      this.produtosLength = null;
      let response = await new Api().get("Produto/retornaQuantidadeProdutos");
      var dados = response.dados;
      this.produtosLength = parseInt(dados.produtos);
    },
    verificarLSIsNull(lsItem) {
      if (localStorage.getItem(lsItem) === null) localStorage.removeItem(lsItem);
    },
    registraLogAcesso: function(obj) {
      let assinatura;
      let nome_usuario;

      let testAssinatura = localStorage.getItem("assinatura");
      if (
        testAssinatura &&
        testAssinatura !== undefined &&
        testAssinatura !== "undefined" &&
        testAssinatura != null
      ) {
        assinatura = JSON.parse(localStorage.getItem("assinatura"));
      }

      if (localStorage.getItem("nome_usuario")) {
        nome_usuario = localStorage.getItem("nome_usuario");
      }

      let objFinal = {
        intIdUsuario: assinatura.id_usuario,
        strNomeUsuario: nome_usuario,
        strIP: assinatura.ip,
        strUrl: obj.strUrl,
        strMetodoHttp: obj.strMetodoHttp,
        intIdItem: obj.intIdItem,
        intIdFerramenta: obj.intIdFerramenta,
        strObjetoClick: obj.strObjetoClick,
        strDestinoClick: obj.strDestinoClick,
        intIdTipoAcao: obj.intIdTipoAcao,
        strTipoAcao: obj.strTipoAcao
      };

      new Log().reportAcesso(objFinal);
    },

    changeBlock: function(direction) {
      this.blCheckAll = false;
      if (direction == "end") {
        if (this.paginaAtual == this.paginaFinal) {
          return;
        } else {
          this.listarProdutos(this.paginaFinal);
        }
      } else if (direction == "first") {
        if (this.paginaAtual == 1) {
          return;
        } else {
          this.listarProdutos(1);
        }
      } else if (direction == "up") {
        if (this.paginaAtual == this.paginaFinal) {
          return;
        } else {
          this.paginaAtual++;
          this.filtrarProdutos(this.paginaAtual);
        }
      } else if (direction == "down") {
        if (this.paginaAtual == 1) {
          return;
        } else {
          this.paginaAtual--;
          this.filtrarProdutos(this.paginaAtual);
        }
      }
    },

    btnFiltrarProdutos: function() {
      if (this.strPesquisa != "") {
        this.produtosFiltrados = this.produtos.filter(
          f =>
            this.removerAcentos(f.nome.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.ncm
              .toLowerCase()
              .replaceAll(".", "")
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", ""))
        );
      } else {
        this.produtosFiltrados = this.produtos;
      }
    },
    filtrarProdutos: function(page) {
      // clearTimeout(this.typeTimeout);

      // this.typeTimeout = setTimeout(() => {

      var that = this;
      this.produtos = [];
      this.blLoadingButton = true;
      this.paginacao = [];
      this.listarPaginas = [];

      if (this.getEmpresa.id === undefined || this.getEmpresa.id == 0) {
        that.blLoadingButton = false;
        return false;
      }

      new Api()
        .post("Produto/filtrarProdutos", {
          termo: this.strPesquisa,
          origem: "p",
          empresa: this.getEmpresa.id,
          limite: this.quantidadeGrid,
          pagina: page
        })
        .then(response => {
          that.produtos = response.dados;

          if (typeof response.mensagem == "object") {
            that.paginacao = response.mensagem;
            that.listarPaginas = that.paginacao.listPages;
            that.blocks = that.paginacao.blocks;
          }

          that.produtos = that.produtos.filter(p => {
            if (typeof p.destinacao[0] !== "undefined") p.destinacao = p.destinacao[0];
            return true;
          });

          that.blLoadingButton = false;
          that.blLoadingFiltrar = false;
          that.paginaFinal = response.mensagem.pages;
          this.paginaAtual = page;

          this.listarDestinacao();
        })
        .finally(() => {
          if (this.$router.history.current.name == "addProdutos") {
            this.adicionarProduto();
          }
        })
        .catch(response => {
          if (response.status == undefined) {
            that.blLoadingButton = false;
            that.filteredProdutos = [];
            that.blLoadingButton = false;
            // this.mostra_mensagem('Erro ao carregar Produtos')
          }
        });

      // }, this.doneTypingInterval);
    }
  }
};
